import { useEffect, useState } from "react";
import { Switch, Route, Redirect, useHistory } from "react-router-dom";
import { DemandList } from "./organoids/DemandList";
import { NewFreeDemand } from "./molecules/NewFreeDemand1";
import { DemandDoneBlock } from "./molecules/DemandDoneBlock";
import { pathDemandSubFree, pathDemandSubPay, pathDemandSubGroupServices, pathMain } from "../../common/config/vars";
import { DemandSidebar } from "./molecules/DemandSidebar";
import { DemandTopBar } from "./molecules/DemandTopBar";
import { OrderGroupServices } from "./organoids/OrderGroupServiceList";
import { $accounts, $selectedAccountIdx, AccountsDoneLoading, AddChargesToAccount, AddOwnerTypeToAccount, queryAccounts, updateAccount } from "../../common/accounts2";
import { useStore } from "effector-react";
import "./styles/DemandBlock.css";
import IconLoudspeaker from "../../common/assets/icons/loudspeaker.png";
import "./styles/troubleshoot.css";
import { changeDemsState } from "./logics/demands";
import { getCustomUserAgent, getCustomUserAgentASB, getCustomUserAgentKrk } from "../../common/customUserAgent";
import { $SiteColors } from "../../common/config/company-atts";
import { Preloader } from "../../common/ui/Preloader/preloader";

export const DemandBlock = () => {
  const [loading, setLoading] = useState(false)
  const [updFreeDems, setUpdFreeDems] = useState(false); //указывает на то, нужно ли обновлять заявки
  const history = useHistory()
  const [currSidebarItem, setCurrSidebarItem] = useState("Бесплатные заявки"); //по умолчанию в качестве заголовка показываем бесплатные заявки
  const [hideArchive, setHideArchive] = useState(false); //скрываем архивные заявки
  const [currAccId, setCurrAccId] = useState(-1);
  const [currAccComId, setCurrAccComId] = useState(getCustomUserAgentKrk() == getCustomUserAgent() ? $SiteColors.getState().ComId : getCustomUserAgentASB() == getCustomUserAgent() ? 56 : -1);
  const [hideDemDoneBlock, setHideDemDoneBlock] = useState<boolean>(true); //заполняем при успешном создании бесплатной заявки
  const [hideNewFreeDemWindow, setHideNewFreeDemWindow] = useState<boolean>(true); //заполняем при успешном создании бесплатной заявки

  const { accounts } = useStore($accounts);
  const accSelIdx = useStore($selectedAccountIdx); //индекс текущего выбранного аккаунта

  function goBack() { //нажали на кнопку "Назад"
    history.push(pathMain)
  }
  //эффект запускается после первого рендера
  useEffect(() => {
    if (accounts.length === 0) queryAccounts().then(async res => {
      setLoading(true)

      var bar = new Promise((resolve, reject) => {
        res.accounts.forEach(async (elem, index) => {
          await updateAccount({ account: elem, accounts: res.accounts });
          await AddChargesToAccount({ account: elem, accounts: res.accounts })
          if (getCustomUserAgent() === getCustomUserAgentKrk() || getCustomUserAgent() === getCustomUserAgentASB()) {
            await AddOwnerTypeToAccount({ account: elem, accounts: res.accounts })
          }
          if (index === res.accounts.length - 1) resolve("@");
        })
      })
      bar.then(() => {
        setLoading(false)
        AccountsDoneLoading()
      })
    }); //если список аккаунтов пуст, то вызываем запрос аккаунтов
  }, []);

  //эффект запускается при изменении списка аккаунтов 
  useEffect(() => {
    if (accounts.length != 0) setUpdFreeDems(!updFreeDems); //если список аккаунтов не пуст, то посылаем команду на обнвление заявок
    else changeDemsState(false) //флаг loading ставим false(узазывает на то, что загрузка заявок не происходит в данный момент)
  }, [accounts]);

  //эффект запускается при изменении индекса выбранного аккаунта
  useEffect(() => {
    if (accSelIdx > -1 && accounts.length > 0 && accSelIdx < accounts.length) {
      let acc = accounts[accSelIdx]
      setCurrAccComId(acc.companyId)
      setCurrAccId(acc.id)
      setUpdFreeDems(!updFreeDems);
    } else {
      setCurrAccComId(getCustomUserAgentKrk() == getCustomUserAgent() ? $SiteColors.getState().ComId : 56)
      setCurrAccId(-1)
    }
  }, [accSelIdx, loading]);

  //эффект запускается при изменении элемента, хранящего новую бесплатную заявку
  useEffect(() => {
    if (!hideDemDoneBlock) { //если создали новую беспланую заявку
      setUpdFreeDems(!updFreeDems); //посылаем команду на обнвление заявок
    }
  }, [hideDemDoneBlock]);


  return (
    <section className="page__content" style={{ fontFamily: "SF Pro Display", }} >
      <div className="page__title-container dem-block-title">
        <nav className="page__navigation" style={{ paddingTop: "0" }}>
          <button type="button" className="page__navigation-button" style={{ margin: "auto 0 auto 0" }} onClick={goBack} >
            На главную
          </button>
        </nav>
        <h1 className="dem-block-page-title" style={{ color: $SiteColors.getState().titleColor }}>Заказать</h1>
        <button className="dem-block-btn-new-free-dem" onClick={() => setHideNewFreeDemWindow(false)} >
          <img className="p-2 m-auto" src={IconLoudspeaker} style={{ width: "40px" }} alt="" />
          <div style={{ margin: "auto 0 auto 0" }}>Создать</div>
        </button>
      </div>
      <div style={{ flexDirection: "row", display: "flex" }}>
        <DemandSidebar setCurrItem={setCurrSidebarItem} />
        <div className="dem-block-main">
          {loading ?
            <div className="data-card__loading-container">
              <Preloader small={true} />
              <p className="data-card__text data-card__text_loading">
                Загрузка данных...
              </p>
            </div> :
            <Switch>
              <Route path={pathDemandSubFree} render={(props) => (
                <>
                  <DemandTopBar hideArchive={hideArchive} setHideArchive={setHideArchive} title={currSidebarItem} />
                  <DemandList demandPayType={0} accountId={currAccId} companyId={currAccComId} hideArchive={hideArchive} demsUpd={updFreeDems} />
                </>
              )}
              />
              <Route path={pathDemandSubPay} render={(props) => (
                <>
                  <DemandTopBar hideArchive={hideArchive} setHideArchive={setHideArchive} title={currSidebarItem} />
                  <DemandList demandPayType={1} accountId={currAccId} companyId={currAccComId} hideArchive={hideArchive} demsUpd={updFreeDems} />
                </>
              )} />
              <Route path={pathDemandSubGroupServices} render={(props) => (
                <OrderGroupServices currSidebarItem={currSidebarItem} groupId={props.match.params.groupId} accountId={currAccId} companyId={currAccComId} hideArchive={false} demsUpd={updFreeDems} />
              )} />
              <Route>
                <Redirect to={pathDemandSubFree} />
              </Route>
            </Switch>
          }
        </div>
      </div>
      {!hideNewFreeDemWindow ? <NewFreeDemand setHideDemDoneBlock={setHideDemDoneBlock} setHideNewFreeDemWindow={setHideNewFreeDemWindow} companyId={currAccComId} accountId={currAccId} /> : <></>}
      {!hideDemDoneBlock ? <DemandDoneBlock text={"Ваша заявка успешно отправлена!"} informOnEnd={setHideDemDoneBlock} /> : <></>}
    </section>
  );
};
